module.exports = __webpack_public_path__ + "static/media/user-info.2692f070.jpg";